import { connectStats } from "react-instantsearch-dom";

export default connectStats(function ResultsCount({ nbHits }) {
  return (
    <div className="space-y-2 whitespace-nowrap font-aeonik">
      <h1 className="m-0 text-3xl font-bold text-slate-600">{nbHits}</h1>
      <span className="text-xs font-bold uppercase tracking-wide text-slate-400">
        {nbHits === 1 ? "Ativo encontrado" : "Ativos encontrados"}
      </span>
    </div>
  );
});
